import React, { useState, Fragment } from "react";
import SectionBezel from "components/SectionBezel";
import DebounceTextarea from "components/DebounceTextarea";
import CheckoutAttributeToggle from "components/CheckoutAttributeToggle";
import { getFieldPath } from "utils/form";
import { useFormikContext } from "formik";
import get from "lodash/get";
import ZoneLink from "components/ZoneLink";
import { CHECKOUT_SESSION } from "utils/constants/stripe";
import { getCheckoutAttributesConfig } from "utils/checkout/attributes";

const ReceiverFields = ({ name }) => {
  const [open, setOpen] = useState(false);
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const customerEmailPath = getFieldPath(name, "customer_email");
  const customerEmail = get(values, customerEmailPath);

  const toggleProps = {
    attributes: getCheckoutAttributesConfig({
      name,
      attributes: [CHECKOUT_SESSION.CUSTOMER, CHECKOUT_SESSION.CUSTOMER_EMAIL]
    }),
    open,
    onChange: (updatedOpen) => updatedOpen && setOpen(updatedOpen)
  };

  return (
    <SectionBezel
      header="Customer"
      expandable
      isOpen={open}
      setOpen={setOpen}
      action={<CheckoutAttributeToggle {...toggleProps} />}
    >
      <Fragment>
        <div className="pb3">
          <DebounceTextarea
            label="Email"
            name={customerEmailPath}
            inputValue={customerEmail}
            placeholder="someone@email.com"
            debounce={500}
            valueSet={(val) => {
              setFieldValue(customerEmailPath, val);
              if (!get(touched, customerEmailPath)) {
                setFieldTouched(customerEmailPath, true);
              }
            }}
          />
        </div>
        <div className="flex flex-column pv3 bt hairline-1">
          <div className="f6 lh-copy">
            If you want to attribute this payment link to a single customer, set
            their email address above. Alternatively, you can use dynamic
            attribution by setting query string parameters.
          </div>
          <div className="pt2">
            <ZoneLink
              href="/learn/payment-links/attribution"
              zone
              linkProps={{
                className: "link",
                target: "_blank"
              }}
            >
              <div className="f6 fw6 link__decoration--hover color-primary pointer">
                Learn more
              </div>
            </ZoneLink>
          </div>
        </div>
      </Fragment>
    </SectionBezel>
  );
};

export default ReceiverFields;
